export const CARD_WIDTH = 320;

export const dimension = {
  width: CARD_WIDTH,
  height: 320,
};
